import ConnectWallet from "../components/ConnectWallet";
import GalleryItem from "../components/GalleryItem";
import Menu from "../components/Menu";
import ScrollTop from "../components/ScrollTop";
import {
  accessories,
  body,
  bracelets,
  eyes,
  glasses,
  headwear,
  mouth,
  necklace,
  place,
  shoes,
  suit,
  tail,
  weapon,
  wings,
} from "../constants/gallery";
import { useEffect, useState, useRef } from "react";
export default function Gallery() {
  const [routeBody, setRouteBody] = useState(false);
  const [routeAccessories, setRouteAccessories] = useState(false);
  const [routeHeadware, setRouteHeadware] = useState(false);
  const [routeNecklace, setRouteNecklace] = useState(false);
  const [routeBracelets, setRouteBracelets] = useState(false);
  const [routeSuit, setRouteSuit] = useState(false);
  const [routeGlasses, setRouteGlasses] = useState(false);
  const [routeWings, setRouteWings] = useState(false);
  const [routeWeapon, setRouteWeapon] = useState(false);
  const [routeEyes, setRouteEyes] = useState(false);
  const [routeMouth, setRouteMouth] = useState(false);
  const [routeTail, setRouteTail] = useState(false);
  const [routeShoes, setRouteShoes] = useState(false);
  const [routePlace, setRoutePlace] = useState(false);

  const refBody = useRef();
  const refAccessories = useRef();
  const refHeadware = useRef();
  const refNecklace = useRef();
  const refBracelets = useRef();
  const refSuit = useRef();
  const refGlasses = useRef();
  const refWings = useRef();
  const refWeapon = useRef();
  const refEyes = useRef();
  const refMouth = useRef();
  const refTail = useRef();
  const refShoes = useRef();
  const refPlace = useRef();

  useEffect(() => {
    if (routeBody) {
      refBody.current.scrollIntoView({ behavior: "smooth" });
      setRouteBody(false);
    }
  }, [routeBody]);

  useEffect(() => {
    if (routeAccessories) {
      refAccessories.current.scrollIntoView({ behavior: "smooth" });
      setRouteAccessories(false);
    }
  }, [routeAccessories]);

  useEffect(() => {
    if (routeHeadware) {
      refHeadware.current.scrollIntoView({ behavior: "smooth" });
      setRouteHeadware(false);
    }
  }, [routeHeadware]);

  useEffect(() => {
    if (routeNecklace) {
      refNecklace.current.scrollIntoView({ behavior: "smooth" });
      setRouteNecklace(false);
    }
  }, [routeNecklace]);

  useEffect(() => {
    if (routeBracelets) {
      refBracelets.current.scrollIntoView({ behavior: "smooth" });
      setRouteBracelets(false);
    }
  }, [routeBracelets]);

  useEffect(() => {
    if (routeSuit) {
      refSuit.current.scrollIntoView({ behavior: "smooth" });
      setRouteSuit(false);
    }
  }, [routeSuit]);

  useEffect(() => {
    if (routeGlasses) {
      refGlasses.current.scrollIntoView({ behavior: "smooth" });
      setRouteGlasses(false);
    }
  }, [routeGlasses]);

  useEffect(() => {
    if (routeWings) {
      refWings.current.scrollIntoView({ behavior: "smooth" });
      setRouteWings(false);
    }
  }, [routeWings]);

  useEffect(() => {
    if (routeWeapon) {
      refWeapon.current.scrollIntoView({ behavior: "smooth" });
      setRouteWeapon(false);
    }
  }, [routeWeapon]);

  useEffect(() => {
    if (routeEyes) {
      refEyes.current.scrollIntoView({ behavior: "smooth" });
      setRouteEyes(false);
    }
  }, [routeEyes]);

  useEffect(() => {
    if (routeMouth) {
      refMouth.current.scrollIntoView({ behavior: "smooth" });
      setRouteMouth(false);
    }
  }, [routeMouth]);

  useEffect(() => {
    if (routeTail) {
      refTail.current.scrollIntoView({ behavior: "smooth" });
      setRouteTail(false);
    }
  }, [routeTail]);

  useEffect(() => {
    if (routeShoes) {
      refShoes.current.scrollIntoView({ behavior: "smooth" });
      setRouteShoes(false);
    }
  }, [routeShoes]);

  useEffect(() => {
    if (routePlace) {
      refPlace.current.scrollIntoView({ behavior: "smooth" });
      setRoutePlace(false);
    }
  }, [routePlace]);

  return (
    <div className="galleryContainer">
      <Menu />
      <ScrollTop />
      <ConnectWallet />
      {/* <img src={bgHeader} alt='bg header' className='bgHeader' />
      <img src={bgFooter} alt='bg header' className='bgFooter'/> */}
      <div className="pageTitle">GALLERY</div>
      <div className="galleryContent">
        <div className="catalogue">
          <div className="catalogueTitle">GALLERY</div>
          <div className="cataloguePartRow">
            <div className="cataloguePart" onClick={() => setRouteBody(true)}>
              BODY TYPES
            </div>
            <div
              className="cataloguePart"
              onClick={() => setRouteAccessories(true)}
            >
              FIN ACCESSORIES
            </div>
            <div
              className="cataloguePart"
              onClick={() => setRouteHeadware(true)}
            >
              HEADWEAR
            </div>
          </div>
          <div className="cataloguePartRow">
            <div
              className="cataloguePart"
              onClick={() => setRouteNecklace(true)}
            >
              NECKLACE
            </div>
            <div
              className="cataloguePart"
              onClick={() => setRouteBracelets(true)}
            >
              BRACELETS
            </div>
            <div className="cataloguePart" onClick={() => setRouteSuit(true)}>
              SUIT
            </div>
          </div>
          <div className="cataloguePartRow">
            <div
              className="cataloguePart"
              onClick={() => setRouteGlasses(true)}
            >
              GLASSES
            </div>
            <div className="cataloguePart" onClick={() => setRouteWings(true)}>
              WINGS
            </div>
            <div className="cataloguePart" onClick={() => setRouteWeapon(true)}>
              WEAPON
            </div>
          </div>
          <div className="cataloguePartRow">
            <div className="cataloguePart" onClick={() => setRouteEyes(true)}>
              EYES
            </div>
            <div className="cataloguePart" onClick={() => setRouteMouth(true)}>
              MOUTH
            </div>
            <div className="cataloguePart" onClick={() => setRouteTail(true)}>
              TAIL
            </div>
          </div>
          <div className="cataloguePartRow">
            <div className="cataloguePart" onClick={() => setRouteShoes(true)}>
              SHOES
            </div>
            <div className="cataloguePart" onClick={() => setRoutePlace(true)}>
              PLACE OF BIRTH
            </div>
          </div>
        </div>
        <div className="galleryDetail">
          {/********************** BODY TYPES ***********************/}
          <div className="galleryPart" ref={refBody}>
            <div className="galleryPartTitle">BODY TYPES</div>
            <div className="galleryList">
              {body.map((item, index) => {
                return (
                  <GalleryItem
                    img={item.img}
                    name={item.name}
                    rarity={item.rarity}
                  />
                );
              })}
            </div>
          </div>

          {/********************** FIN ACCESSORIES ***********************/}
          <div className="galleryPart" ref={refAccessories}>
            <div className="galleryPartTitle">FIN ACCESSORIES</div>
            <div className="galleryList">
              {accessories.map((item, index) => {
                return (
                  <GalleryItem
                    img={item.img}
                    name={item.name}
                    rarity={item.rarity}
                  />
                );
              })}
            </div>
          </div>

          {/********************** HEADWEAR ***********************/}
          <div className="galleryPart" ref={refHeadware}>
            <div className="galleryPartTitle">HEADWEAR</div>
            <div className="galleryList">
              {headwear.map((item, index) => {
                return (
                  <GalleryItem
                    img={item.img}
                    name={item.name}
                    rarity={item.rarity}
                  />
                );
              })}
            </div>
          </div>

          {/********************** NECKLACE ***********************/}
          <div className="galleryPart" ref={refNecklace}>
            <div className="galleryPartTitle">NECKLACE</div>
            <div className="galleryList">
              {necklace.map((item, index) => {
                return (
                  <GalleryItem
                    img={item.img}
                    name={item.name}
                    rarity={item.rarity}
                  />
                );
              })}
            </div>
          </div>

          {/********************** BRACELETS ***********************/}
          <div className="galleryPart" ref={refBracelets}>
            <div className="galleryPartTitle">BRACELETS</div>
            <div className="galleryList">
              {bracelets.map((item, index) => {
                return (
                  <GalleryItem
                    img={item.img}
                    name={item.name}
                    rarity={item.rarity}
                  />
                );
              })}
            </div>
          </div>

          {/********************** SUIT ***********************/}
          <div className="galleryPart" ref={refSuit}>
            <div className="galleryPartTitle">SUIT</div>
            <div className="galleryList">
              {suit.map((item, index) => {
                return (
                  <GalleryItem
                    img={item.img}
                    name={item.name}
                    rarity={item.rarity}
                  />
                );
              })}
            </div>
          </div>

          {/********************** GLASSES ***********************/}
          <div className="galleryPart" ref={refGlasses}>
            <div className="galleryPartTitle">GLASSES</div>
            <div className="galleryList">
              {glasses.map((item, index) => {
                return (
                  <GalleryItem
                    img={item.img}
                    name={item.name}
                    rarity={item.rarity}
                  />
                );
              })}
            </div>
          </div>

          {/********************** WINGS ***********************/}
          <div className="galleryPart" ref={refWings}>
            <div className="galleryPartTitle">WINGS</div>
            <div className="galleryList">
              {wings.map((item, index) => {
                return (
                  <GalleryItem
                    img={item.img}
                    name={item.name}
                    rarity={item.rarity}
                  />
                );
              })}
            </div>
          </div>

          {/********************** WEAPON ***********************/}
          <div className="galleryPart" ref={refWeapon}>
            <div className="galleryPartTitle">WEAPON</div>
            <div className="galleryList">
              {weapon.map((item, index) => {
                return (
                  <GalleryItem
                    img={item.img}
                    name={item.name}
                    rarity={item.rarity}
                  />
                );
              })}
            </div>
          </div>

          {/********************** EYES ***********************/}
          <div className="galleryPart" ref={refEyes}>
            <div className="galleryPartTitle">EYES</div>
            <div className="galleryList">
              {eyes.map((item, index) => {
                return (
                  <GalleryItem
                    img={item.img}
                    name={item.name}
                    rarity={item.rarity}
                  />
                );
              })}
            </div>
          </div>

          {/********************** MOUTH ***********************/}
          <div className="galleryPart" ref={refMouth}>
            <div className="galleryPartTitle">MOUTH</div>
            <div className="galleryList">
              {mouth.map((item, index) => {
                return (
                  <GalleryItem
                    img={item.img}
                    name={item.name}
                    rarity={item.rarity}
                  />
                );
              })}
            </div>
          </div>

          {/********************** TAIL ***********************/}
          <div className="galleryPart" ref={refTail}>
            <div className="galleryPartTitle">TAIL</div>
            <div className="galleryList">
              {tail.map((item, index) => {
                return (
                  <GalleryItem
                    img={item.img}
                    name={item.name}
                    rarity={item.rarity}
                  />
                );
              })}
            </div>
          </div>

          {/********************** SHOES ***********************/}
          <div className="galleryPart" ref={refShoes}>
            <div className="galleryPartTitle">SHOES</div>
            <div className="galleryList">
              {shoes.map((item, index) => {
                return (
                  <GalleryItem
                    img={item.img}
                    name={item.name}
                    rarity={item.rarity}
                  />
                );
              })}
            </div>
          </div>

          {/********************** PLACE OF BIRTH ***********************/}
          <div className="galleryPart" ref={refPlace}>
            <div className="galleryPartTitle">PLACE OF BIRTH</div>
            <div className="galleryList">
              {place.map((item, index) => {
                return (
                  <GalleryItem
                    img={item.img}
                    name={item.name}
                    rarity={item.rarity}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="footerBrand">@Sharktopia 2021</div>
      </div>
    </div>
  );
}
